import React from 'react';
import * as d3 from 'd3';
import { useI18n } from '@whizz/react-i18n';
import type { HighlightedProps, SchoolReportType } from '../../types';
import { SectionLayout } from '../modules';
import { StudentProgress } from '../../../components';
import type { ChartDataType, ChartIconType } from '../../../components/charts/types';

type Props = {
  schoolReport: SchoolReportType;
  showOthersData: boolean;
  iconToUse: ChartIconType
} & HighlightedProps;

const SchoolProgressions = ({ schoolReport, showOthersData, highlightedLabel, highlightedIds, iconToUse, onElementClick }: Props): JSX.Element => {
  const { translate } = useI18n();
  const value = (schoolReport.average.progressionAverage ?? 0).toFixed(2);

  const getHighlightedAvg = (): string | null => {
    if (highlightedIds && highlightedIds.length > 0) {
      const mean = d3.mean(dataToUse().map((cl) => {
        if (highlightedIds.includes(cl.id)) {
          return cl.chartsData?.progression;
        }
      }));
      return mean != undefined ? mean.toFixed(2) : null;
    }

    return null;
  };

  const dataToUse = (): ChartDataType[] => {
    if (iconToUse === 'class') {
      return schoolReport.classes;
    } else return schoolReport.yearGroups;
  };

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.title')}
      value={showOthersData ? value : null}
      highlightLabel={highlightedLabel}
      highlightValue={getHighlightedAvg()}
      description={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.description')}
      moreInfo={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.info')}
      id={'school-progressions-container'}
    >
      <StudentProgress
        showOthersData={showOthersData}
        data={dataToUse()}
        chartType={'progression'}
        type={iconToUse}
        highlightedIds={highlightedIds}
        onElementClick={onElementClick}
      />
    </SectionLayout>
  );
};

SchoolProgressions.displayName = 'SchoolProgressions';

export default SchoolProgressions;
